import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import Button from "primevue/button";
import CompanyField from "@/components/blocks/CompanyField.vue";
import InputField from "@/components/blocks/InputField.vue";
import Panel from "primevue/panel";
import {inject, reactive, ref} from "vue";
import {AxiosStatic} from "axios";
import {Company, InvoicePreview} from "@/components/blocks/Types";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import InvoiceListPreview from "@/views/private/tax/InvoiceListPreview.vue";

// Define types
type FormData = {
    year: number | null
    company: Company | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaxView',
  setup(__props) {


const rules = {
    company: {required},
    year: {required},
}

// Define model
const model = reactive<FormData>({
    year: 2022,
    company: null
});

const invoices = ref<InvoicePreview[]>([])
const submitted = ref<boolean>(false)

// Inject dependencies
const axios = inject<AxiosStatic>('axios')

//Define used properties
const v$ = useVuelidate(rules, model)


// Define functions
function handleSubmit(valid: boolean) {
    submitted.value = true
    if (valid) {
        const url = `/dph/tax-report/${model.year}/${model.company.id}`
        axios?.get(url).then(response => {
            if (response.status >= 200 && response.status <= 299) {
                invoices.value = response.data.invoices
            } else {
                console.error('Tax Report error', response)
            }
        })
    }
}

function generateBulkForCurrent() {
    console.log('Generate bulk for ', model)
    axios?.get(`/dph/download/tax-report/${model.year}/${model.company.id}`, {
        responseType: 'blob'
    }).then(response => {

        const objectURL = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = objectURL
        link.setAttribute('download', `${model.company.ic}-tax-${model.year}` + '.zip')
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(link.href)
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Panel), {
      header: "Podklady daňového přiznání",
      class: "mt-2 mb-2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
          class: "p-fluid"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CompanyField, {
                id: "company",
                class: "col-2",
                modelValue: _unref(v$).company.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).company.$model) = $event)),
                vualidate: _unref(v$).company,
                submitted: submitted.value,
                label: "Společnost"
              }, null, 8, ["modelValue", "vualidate", "submitted"]),
              _createVNode(InputField, {
                id: "year",
                class: "field col-2",
                label: "Rok",
                modelValue: _unref(v$).year.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).year.$model) = $event)),
                submitted: submitted.value,
                vualidate: _unref(v$).year
              }, null, 8, ["modelValue", "submitted", "vualidate"]),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_unref(Button), {
                  type: "submit",
                  label: "Generovat"
                })
              ])
            ])
          ])
        ], 32)
      ]),
      _: 1
    }),
    _createVNode(InvoiceListPreview, {
      invoices: invoices.value,
      onGenerateBulkRequest: generateBulkForCurrent
    }, null, 8, ["invoices"])
  ], 64))
}
}

})